// extracted by css-extract-rspack-plugin
export default {"radio":"RadioIcon-module__radio--M864D","active":"RadioIcon-module__active--Mzhn1","disabled":"RadioIcon-module__disabled--O21UR","highlight":"RadioIcon-module__highlight--PSL5t"};